var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-bubble",class:{
    'dark-theme': _vm.isTextColourLight,
    'show': _vm.hasUserTyping,
  }},[_vm._m(0),_vm._v("\n  "+_vm._s(_vm.$t('Participants are typing'))+"\n")])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"typing"},[_c('div',{staticClass:"dot"}),_c('div',{staticClass:"dot"}),_c('div',{staticClass:"dot"})])}]

export { render, staticRenderFns }